import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PouchOperationFilterEntity } from '../../domain/entities/PouchOperationFilterEntity'
export class PouchOperationFilterModel extends PouchOperationFilterEntity {
  userId?: string
  fromDate?: string
  toDate?: string
  fromPouchDriverId?: number
  constructor(dataDto: PouchOperationFilterEntity) {
    super()
    mapEntityProperties<PouchOperationFilterModel>(this, dataDto, {
      exclude: ['user', 'startDate', 'endDate', 'fromPouchDriver'],
      map: {
        userId: dataDto.user?.id,
        fromDate: dataDto.startDate,
        toDate: dataDto.endDate,
        fromPouchDriverId: dataDto.fromPouchDriver?.id
      }
    })
  }
}
